import { HttpErrorResponse } from "@angular/common/http";
import { DocumentType } from "@helper/abstraction/documents";
import { MobileEdsMsg, MobileEdsOperation } from "@helper/abstraction/sccrypto";
import { createAction } from "@ngrx/store";

//#region save document for mobile signing
export const saveDocumentMobile = createAction(
	"[Document Sign Mobile] Save Document Mobile",
	(document: any, documentType: DocumentType, isVersion?: boolean): { document: any; documentType: DocumentType, isVersion?: boolean } => ({ document, documentType, isVersion })
);

export const saveDocumentMobileError = createAction(
	"[Document Sign Mobile] Save Document Mobile Error",
	(payload: HttpErrorResponse): { error: HttpErrorResponse } => ({ error: payload })
);

export const saveDocumentMobileSuccess = createAction(
	"[Document Sign Mobile] Save Document Mobile Success",
	(id: number): { id: number } => ({ id })
);
//#endregion

//#region signature mobile type

export const signatureMobileTypeOperation = createAction(
	"[Document Sign Mobile] Signature Mobile Type Operation",
	(value: MobileEdsMsg, mobileType: string, operationType: string, isVersion?: boolean, status?: string): { value: MobileEdsMsg; mobileType: string; operationType: string; isVersion?: boolean; status?: string } => ({ value, mobileType, operationType, isVersion, status })
);

export const signatureMobileTypeOperationSuccess = createAction(
	"[Document Sign Mobile] Signature Mobile Type Operation Success",
	(payload: { signatureMobile: MobileEdsOperation; id: string, status?: string, originalId?: number }): { signatureMobile: MobileEdsOperation; id: string; status?: string, originalId?: number } => (payload)
);

export const signatureMobileTypeOperationError = createAction(
	"[Document Sign Mobile] Signature Mobile Type Operation Error",
	(payload: { error: HttpErrorResponse; id: string }): { error: HttpErrorResponse; id: string } => ({ error: payload.error, id: payload.id })
);
//#endregion

export const markAsRead = createAction(
	"[Documents] Mark As Read",
	(ids: number[], docType: DocumentType, isVersion?: boolean): { ids: number[]; docType: DocumentType, isVersion?: boolean } => ({ ids, docType, isVersion })
);
export const markAsReadSuccess = createAction(
	"[Documents] Mark As Read Success",
);
export const markAsReadError = createAction(
	"[Documents] Mark As Read Error",
	(payload: HttpErrorResponse): { error: HttpErrorResponse } => ({ error: payload })
);
